import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropArea", "preview", "previewImg", "destroy"]

  dragover(event) {
    event.preventDefault()
    this.dropAreaTarget.classList.add("border-[#5B8BF5]", "bg-blue-50/50")
  }

  dragleave() {
    this.dropAreaTarget.classList.remove("border-[#5B8BF5]", "bg-blue-50/50")
  }

  drop(event) {
    event.preventDefault()
    this.dropAreaTarget.classList.remove("border-[#5B8BF5]", "bg-blue-50/50")
    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.inputTarget.files = files
      this.showPreview(files[0])
    }
  }

  select() {
    this.inputTarget.click()
  }

  changed() {
    const files = this.inputTarget.files
    if (files.length > 0) {
      this.showPreview(files[0])
    }
  }

  remove() {
    this.inputTarget.value = ""
    this.dropAreaTarget.style.display = ""
    this.previewTarget.style.display = "none"
    if (this.hasDestroyTarget) {
      this.destroyTarget.value = "true"
    }
  }

  showPreview(file) {
    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewImgTarget.src = e.target.result
      this.dropAreaTarget.style.display = "none"
      this.previewTarget.style.display = ""
    }
    reader.readAsDataURL(file)
  }
}
